export var IdDefaultThreshold;
(function (IdDefaultThreshold) {
    // TODO: "25" is default threshold value, should come from settings
    IdDefaultThreshold[IdDefaultThreshold["GoldSpendConfirmAmount"] = 25] = "GoldSpendConfirmAmount";
    IdDefaultThreshold[IdDefaultThreshold["FreeDogTreatExchange"] = 12] = "FreeDogTreatExchange";
    IdDefaultThreshold[IdDefaultThreshold["PlayerLeagueCompetitionThreshold"] = 2] = "PlayerLeagueCompetitionThreshold";
    IdDefaultThreshold[IdDefaultThreshold["CoopLeagueCompetitionThreshold"] = 2] = "CoopLeagueCompetitionThreshold";
    IdDefaultThreshold[IdDefaultThreshold["playerFieldsRequiredToBeExperiencedPlayer"] = 4] = "playerFieldsRequiredToBeExperiencedPlayer";
})(IdDefaultThreshold || (IdDefaultThreshold = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdDefaultThreshold.ts
// module id = 283
// module chunks = 3